import React, { useEffect, useRef, useState } from 'react';
import { bibleConfig } from '../data/bibleConfig';
import { safeUrl } from '../utils/safeUrl';
export function BibleVsl() {
  const [playerLoaded, setPlayerLoaded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (playerLoaded) return;
    const node = containerRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setPlayerLoaded(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.4
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [playerLoaded]);
  const mp4 = safeUrl(bibleConfig.vslMp4Url);
  const poster = safeUrl(bibleConfig.vslPosterUrl);
  const embed = safeUrl(bibleConfig.vslEmbedUrl);
  const hasVideo = Boolean(mp4 || embed);
  const facade = <div className="max-w-[560px] px-6 py-6" data-id="element-87" data-mp="3vbls1btwoi72">
      <span aria-hidden="true" className="mb-3 block text-[35px] text-[#e9c769]" data-id="element-88" data-mp="3vcdffzdcn9m9">
        ▶
      </span>
      <strong data-id="element-89" data-mp="1y6sujcrgxe0t">De la idea a la instrucción</strong>
      <p className="mt-2 text-[#beb9b0]" data-id="element-90" data-mp="1tbdfihhq5c2t">
        Una mirada al método y al contenido de Visual Disruption Bible 2.0.
      </p>
      {!hasVideo ? <p className="mt-2 hidden text-[13px] text-[#beb9b0] sm:block" data-id="element-91" data-mp="22as41bebzcko">
          Presentación en video próximamente.
        </p> : null}
    </div>;
  return <div ref={containerRef} id="vsl-player" className="grid aspect-video place-items-center overflow-hidden rounded-xl border border-[#7b663b] bg-[radial-gradient(ellipse,#30291b,#111114_70%)] text-center" data-id="element-92" data-mp="2gxtofmdqejdi">
      {playerLoaded && mp4 ? <video controls autoPlay muted playsInline preload="metadata" src={mp4} poster={poster ?? undefined} aria-label="Presentación de Visual Disruption Bible 2.0" className="h-full w-full object-contain" data-id="element-93" data-mp="2lyhpl0vocglg" /> : playerLoaded && embed ? <iframe src={`${embed}${embed.includes('?') ? '&' : '?'}autoplay=1&muted=1`} title="Presentación de Visual Disruption Bible 2.0" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen loading="lazy" referrerPolicy="strict-origin-when-cross-origin" className="h-full w-full border-0" data-id="element-94" data-mp="2qrkvyx8556qz" /> : hasVideo ? <button type="button" onClick={() => setPlayerLoaded(true)} aria-label="Reproducir la presentación" className="group grid h-full w-full place-items-center transition-transform duration-300 hover:scale-[1.01] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#e9c769]" data-id="element-95" data-mp="3emxf34z0w3iy">
          {facade}
        </button> : facade}
    </div>;
}